// extracted by css-extract-rspack-plugin
var _1 = "zyMPrVyvqkMA8gDL";
var _2 = "ppEonnbCoqUWC3OI";
var _3 = "Uh0DY312cjwIraw0";
var _4 = "V6kfJ3z5sHEvLWPa";
var _5 = "VSnYvWmgKaIZsmHk";
var _6 = "ABz9HAvYoVsHGnox";
var _7 = "VpNuN7hAbwx7LinO";
var _8 = "Btc20bZ32QgWCBOP";
var _9 = "VZamdhvF7AhiC4l3";
var _a = "hucnCQgEoSUu1O5k";
export { _1 as "tabs", _2 as "tabsFullWidthBorder", _3 as "tabsFullWidthBorderDark", _4 as "tabsFullWidthBorderFullDark", _5 as "tabsFullWidthBorderGray", _6 as "tabsFullWidthBorderInvertDark", _7 as "tabsFullWidthBorderWarm", _8 as "tiles", _9 as "tilesContained", _a as "wFull" }
// extracted by css-extract-rspack-plugin
var _1 = "zyMPrVyvqkMA8gDL";
var _2 = "ppEonnbCoqUWC3OI";
var _3 = "Uh0DY312cjwIraw0";
var _4 = "V6kfJ3z5sHEvLWPa";
var _5 = "VSnYvWmgKaIZsmHk";
var _6 = "ABz9HAvYoVsHGnox";
var _7 = "VpNuN7hAbwx7LinO";
var _8 = "Btc20bZ32QgWCBOP";
var _9 = "VZamdhvF7AhiC4l3";
var _a = "hucnCQgEoSUu1O5k";
export { _1 as "tabs", _2 as "tabsFullWidthBorder", _3 as "tabsFullWidthBorderDark", _4 as "tabsFullWidthBorderFullDark", _5 as "tabsFullWidthBorderGray", _6 as "tabsFullWidthBorderInvertDark", _7 as "tabsFullWidthBorderWarm", _8 as "tiles", _9 as "tilesContained", _a as "wFull" }
